import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-mini-tablo',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="tablo-kapsayici">
      <table>
        @if (basliklar()?.length) {
          <thead>
            <tr>
              @for (b of basliklar(); track $index) {
                <th>{{ b }}</th>
              }
            </tr>
          </thead>
        }
        <tbody>
          @for (satir of satirlar(); track $index; let i = $index) {
            <tr [class.zebra]="i % 2 === 1">
              @for (hucre of satir; track $index) {
                <td>{{ hucre }}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .tablo-kapsayici { max-height: 240px; overflow-y: auto; overflow-x: auto; }
    table { width: 100%; border-collapse: collapse; font-size: 11px; }
    th {
      text-align: left; padding: 5px 8px; font-weight: 600;
      color: var(--py-metin-ikincil, #8c8c8c);
      border-bottom: 1px solid var(--py-border, rgba(0,0,0,0.06));
      position: sticky; top: 0;
      background: var(--py-arkaplan, #fff);
      white-space: nowrap;
    }
    td {
      padding: 4px 8px;
      color: var(--py-metin, #262626);
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 160px;
    }
    tr.zebra { background: var(--py-hover, rgba(0,0,0,0.02)); }
    tbody tr { transition: background 0.15s; }
    tbody tr:hover { background: var(--py-hover, rgba(0,0,0,0.04)); }
  `],
})
export class MiniTabloComponent {
  basliklar = input<string[]>([]);
  satirlar = input<any[][]>([]);
}
